"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactBootstrap = require("react-bootstrap");

var _ToolDetails = _interopRequireDefault(require("./ToolDetails")); // import { TOOL_BAR_HOVER_MESSAGE } from '../../config/config';


var ToolColumn = function ToolColumn(_ref) {
  var styleClasses = _ref.styleClasses,
      type = _ref.type,
      onDragStartCallback = _ref.onDragStartCallback;
  return (
    /*#__PURE__*/
    _react["default"].createElement(_reactBootstrap.Col, {
      className: "col-4 text-center " + styleClasses
    },
    /*#__PURE__*/
    _react["default"].createElement("div", {
      className: type + "Field hoverBackgroundColor field-box",
      style: {
        cursor: 'grab',
        type: 'text/css'
      },
      draggable: "true" // eslint-disable-next-line jsx-a11y/aria-role
      ,
      role: "draggable",
      onDragStart: function onDragStart(e) {
        return onDragStartCallback(e, type);
      },
      "data-cy": type + "-field"
    },
    /*#__PURE__*/
    _react["default"].createElement(_ToolDetails["default"], {
      type: type
    })))
  );
};

ToolColumn.defaultProps = {
  styleClasses: '',
  type: 'text-field'
};
ToolColumn.propTypes = process.env.NODE_ENV !== "production" ? {
  styleClasses: _propTypes["default"].string,
  type: _propTypes["default"].string,
  onDragStartCallback: _propTypes["default"].func.isRequired
} : {};

var _default = exports["default"] = ToolColumn;